import React from 'react';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import './PageAuditFields.scss';
import { useEventHub } from '@pwc/event-hub-ui';

/* 
  Luxon parse to 'jp' doesn't show the kanji as shown in this issue: https://github.com/moment/luxon/issues/549#issuecomment-563900490
  Workaround is to show Traditional Hong Kong locale instead as they have the same 12月 format.
*/
const LUXON_JAPANESE_LOCALE_WORKAROUND = 'zh';

const PageAuditFields = ({
  dateModified,
  dateShared,
  modifiedBy,
  shareWithAll,
  version,
}) => {
  const { t } = useTranslation();
  const { eventHub } = useEventHub();
  const currentLang = eventHub?.getCurrentLang();
  return (
    <p className="page-audit-fields" data-testid="page-audit-fields">
      <span className="text-lastupdated bold">
        {version && `v${version} `}
        {shareWithAll ? t('lastShared') : t('lastUpdated')}
      </span>{' '}
      <span>
        <span className="text-timestamp">
          {DateTime.fromISO(dateShared || dateModified, {
            zone: 'utc',
          })
            .setLocale(
              currentLang === 'jp' ? LUXON_JAPANESE_LOCALE_WORKAROUND : 'en'
            )
            .toLocal()
            .toFormat('H:mm ZZZZ - d LLL yyyy')}
        </span>
        {modifiedBy && ` ${t('by')} ${modifiedBy}`}
      </span>
    </p>
  );
};

export default PageAuditFields;
